module.exports = __webpack_public_path__ + "static/img/number2.970e44c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/number2.png
// module id = 02tx
// module chunks = 3